export const API_BASE_URL = String(process.env.REACT_APP_API_BASE_URL || "")
  .trim()
  .replace(/\/+$/, "");

export const getApiUrl = (endpoint) => {
  const endpointValue = String(endpoint || "").trim();
  if (!endpointValue) return API_BASE_URL || window.location.origin;

  if (/^https?:\/\//i.test(endpointValue)) {
    return endpointValue;
  }

  const normalizedEndpoint = endpointValue.startsWith("/")
    ? endpointValue
    : `/${endpointValue}`;

  if (API_BASE_URL.toLowerCase().endsWith("/api") && normalizedEndpoint.toLowerCase().startsWith("/api/")) {
    return API_BASE_URL + normalizedEndpoint.slice(4);
  }

  return API_BASE_URL ? API_BASE_URL + normalizedEndpoint : normalizedEndpoint;
};
